module.exports = __webpack_public_path__ + "static/media/tomchi.c9dfd6e7.png";